import React from 'react';
import { IconProps } from '../types';

const SparklesIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
      <path d="M9 5L10 7L12 6L10 7L9 9L8 7L6 6L8 7L9 5Z" />
      <path d="M18 14L19 16L21 15L19 16L18 18L17 16L15 15L17 16L18 14Z" />
    </svg>
  );
};

export default SparklesIcon;
